import { Text, Badge, Box, Divider, Flex, Icon } from '@chakra-ui/react';
import { useTranslation } from 'helpers/languages/translations';
import icons from 'shared/icons';
import { tableToolbarStyle } from 'shared/styles';

const FilterButton = ({
    title,
    nb,
    value,
    activeFilter,
    setActiveFilter,
}: {
    title: string;
    nb: number;
    value?: string;
    activeFilter?: string;
    setActiveFilter?: (filter: string | undefined) => void;
}) => {
    return (
        <Flex
            alignItems="center"
            onClick={() => setActiveFilter?.(value)}
            cursor="pointer"
            p={2}
            borderRadius={3}
            fontWeight={activeFilter === value ? 'bold' : 'normal'}
            bg={activeFilter === value ? 'gray.100' : 'transparent'}
        >
            <Text flexGrow={1}>{title}</Text>
            <Badge bg={activeFilter === value ? 'gray.50' : 'gray.100'}>{nb}</Badge>
        </Flex>
    );
};

const style = {
    width: '20%',
    backgroundColor: 'gray.50',
    borderRadius: '8px',
    padding: '16px',
    border: '1px solid',
    borderColor: 'gray.100',
};

const FilterPanel = ({
    activeFilter,
    setActiveFilter,
    globalFilters = [],
    otherFilters = [],
}: {
    activeFilter?: string;
    globalFilters?: { title: string; value?: string; nb: number }[];
    otherFilters?: { title: string; value?: string; nb: number }[];
    setActiveFilter?: (filter: string | undefined) => void;
}) => {
    const translate = useTranslation();

    return (
        <Box {...style}>
            {globalFilters.map((filter, index: number) => (
                <FilterButton key={index} {...filter} activeFilter={activeFilter} setActiveFilter={setActiveFilter} />
            ))}
            {otherFilters?.length > 0 && (
                <>
                    <Divider my={3} />
                    <Text
                        mb={2}
                        alignItems="center"
                        display="flex"
                        gap={1}
                        textTransform="uppercase"
                        color="gray.500"
                        fontSize="xs"
                        fontWeight="bold"
                    >
                        <Icon as={icons.list} />
                        {translate('keywords.filters.userList')}
                    </Text>
                </>
            )}
            {otherFilters.map((filter, index: number) => (
                <FilterButton key={index} {...filter} activeFilter={activeFilter} setActiveFilter={setActiveFilter} />
            ))}
        </Box>
    );
};

export default FilterPanel;
